import { useMemo } from "react";
import { useRecoilValue } from "recoil";

import { useBookingsNavigation } from "@ryde/redux";
import {
  selectedBookingsSelector,
  selectedCellsBookingsSelector,
  type BookingDto,
} from "@ryde/shared";

/**
 * The bookings a bulk panel acts on, whichever bookings view the user selected them in: the calendar
 * selects cells that each hold several bookings, the grid selects booking rows.
 */
export const useSelectedBulkBookings = (): BookingDto[] => {
  const { isCalendarBookingView } = useBookingsNavigation();
  const selectedCalendarBookings = useRecoilValue(
    selectedCellsBookingsSelector,
  );
  const selectedGridBookings = useRecoilValue(selectedBookingsSelector);

  return useMemo(
    () =>
      isCalendarBookingView ? selectedCalendarBookings : selectedGridBookings,
    [isCalendarBookingView, selectedCalendarBookings, selectedGridBookings],
  );
};
